import { INTERNAL_MAILBOX_TYPE } from '../../constants';
import type { Recipients } from 'owa-editor-sonora-types';

export const getRequiredAttendeesFromRecipients = (
    recipients: Recipients | undefined,
    limit: number,
    shouldKeepInternalAttendeesOnly?: boolean
): string[] => {
    const requiredAttendees: string[] = [];
    if (recipients?.toRecipients) {
        for (const recipient of recipients.toRecipients) {
            if (requiredAttendees.length >= limit) {
                break;
            }
            // If we want internal attendees only (calendar accessible), filter out other mailbox types.
            if (
                !(
                    shouldKeepInternalAttendeesOnly &&
                    recipient.MailboxType !== INTERNAL_MAILBOX_TYPE
                ) &&
                recipient.EmailAddress
            ) {
                requiredAttendees.push(recipient.EmailAddress!);
            }
        }
    }
    return requiredAttendees;
};

export const getOptionalAttendeesFromRecipients = (
    recipients: Recipients | undefined,
    limit: number
): string[] => {
    const optionalAttendees: string[] = [];
    if (recipients?.ccRecipients) {
        for (const recipient of recipients.ccRecipients) {
            if (optionalAttendees.length >= limit) {
                break;
            }
            if (recipient.EmailAddress) {
                optionalAttendees.push(recipient.EmailAddress);
            }
        }
    }
    if (recipients?.bccRecipients) {
        for (const recipient of recipients.bccRecipients) {
            if (!!limit && optionalAttendees.length >= limit) {
                break;
            }
            if (recipient.EmailAddress) {
                optionalAttendees.push(recipient.EmailAddress);
            }
        }
    }
    return optionalAttendees;
};
